import {generateSeoInfo} from '../../modules/seo/seoUtils';

function generateDefaultInitialBrandsState() {
  return {
    brandsBreadcrumbArray: null,
    brandsSeoInfo: null,
    brands: null,
  };
}

function brandsReducer(state = generateDefaultInitialBrandsState(), action) {
  let newState;

  switch (action.type) {
    case 'GET_BRANDS_FULFILLED': {
      const {
        seoInformation: rawSeoInformation,
        brands,
      } = action.payload.response.data.data;

      newState = {
        ...state,
        brandsBreadcrumbArray: rawSeoInformation?.breadcrumbs || [],
        brandsSeoInfo: rawSeoInformation ? generateSeoInfo(rawSeoInformation) : null,
        brands,
      };
      break;
    }

    case 'LEAVE_BRANDS_PAGE_ROUTE': {
      newState = {
        ...state,
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default brandsReducer;
export {generateDefaultInitialBrandsState};
